export const UsersData = [
  {
    id: 1,
    name: 'Roberto',
    lastName: 'Ramirez'
  }
]